import './categoryDescriptionModal.scss';

import { MouseEvent, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, ButtonVariant, Modal, Size } from '@eliberty/design-system-react';

import { findModalPortal } from '~helpers';
import { ProductCategoryInformation } from '~molecules';
import { ProductCategoryAdditionalInfo } from '~types/appsync.types';

interface CategoryDescriptionModalProps {
  additionalInfo: ProductCategoryAdditionalInfo;
  categoryName: string;
}

const CategoryDescriptionModal = ({
  additionalInfo,
  categoryName,
}: CategoryDescriptionModalProps) => {
  const intl = useIntl();
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (e: MouseEvent) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  return (
    <div className='CategoryDescriptionModal'>
      <Button variant={ButtonVariant.Ghost} type='button' onClick={handleOpen} size={Size.S}>
        <FormattedMessage id='moreInformation' defaultMessage='More information' />
      </Button>
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        title={intl.formatMessage({
          defaultMessage: 'Domain information',
          id: 'domainInformation',
        })}
        portalProps={{ target: findModalPortal() }}
        centered
        size={Size.XL}
      >
        <Modal.Body>
          <div className='CategoryDescriptionModal_content'>
            <ProductCategoryInformation title={categoryName} additionalInfo={additionalInfo} />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CategoryDescriptionModal;
